<template>
  <v-stepper-content step="2">
    <v-row style="height: 200px;" justify="center">
      <div>
        <p class="title">
          {{ cameraModel }}
        </p>
        <p class="subtitle-1">
          Push power button and<br>
          Other instructions
        </p>
      </div>
    </v-row>
    <v-row justify="end">
      <v-btn class="ma-3" rounded @click="$emit('update:e1', 1)">Back</v-btn>
      <v-btn
        class="ma-3"
        color="primary"
        @click="nextStep"
        rounded
      >
        Next
      </v-btn>
    </v-row>
  </v-stepper-content>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import EventBus from '@/utils/EventBus';

export default {
  data() {
    return {
    };
  },
  computed: {
    cameraModel() {
      return this.$store.state.cameraModel;
    },
  },
  methods: {
    nextStep() {
      const code = uuidv4();
      EventBus.$emit('device-registration-code-created', code);
      this.$emit('update:e1', 3);
    },
  },
};
</script>
